// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.adminNav[data-v-2d8fb4bc]
	{
		position: sticky;
		top: 0px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		flex-wrap: wrap;
		flex-direction: row;
		background-color: #FFFFFF;
		border-bottom: 1px solid #AAAAAA;
}
.adminNav[data-v-2d8fb4bc] *
		{
			padding: 10px 20px;
			cursor: pointer;
			font-size: 20px;
			color: #000000;
			text-decoration: none;
			flex: 1 1 auto;
			text-align: center;
			background-color: #E8E8E8;
			border-left: 1px solid #AAAAAA;
			border-top: 1px solid #AAAAAA;
			margin-top: -1px;
			margin-left: -1px;
}
.adminNav[data-v-2d8fb4bc] *:hover
			{
				background-color: #F2F2F2;
}
.systemName[data-v-2d8fb4bc]
	{
		background-color: #82bf85;
}
.systemName[data-v-2d8fb4bc]:hover
		{
			background-color: #9bdc9e;
}
.logoutButton[data-v-2d8fb4bc]
	{
		background-color: #ffe4cb;
}
.logoutButton[data-v-2d8fb4bc]:hover
		{
			background-color: #fff6ed;
}
.router-link-active[data-v-2d8fb4bc]
	{
		text-decoration: underline;
}
.linkToClient[data-v-2d8fb4bc]
	{
		background-color: var(--primary-color);
		color: var(--text-color-on-primary-color);
}
.linkToClient[data-v-2d8fb4bc]:hover
		{
			background-color: var(--primary-color-light2);
}
@media (min-width: 600px)
	{
nav[data-v-2d8fb4bc]
		{
			flex-direction: row;
}
}
`, "",{"version":3,"sources":["webpack://./www/vues/admin/AdminMenu.vue"],"names":[],"mappings":";AA4CC;;EAEC,gBAAgB;EAChB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,gCAAgC;AACjC;AAEC;;GAEC,kBAAkB;GAClB,eAAe;GACf,eAAe;GACf,cAAc;GACd,qBAAqB;GACrB,cAAc;GACd,kBAAkB;GAClB,yBAAyB;GACzB,8BAA8B;GAC9B,6BAA6B;GAC7B,gBAAgB;GAChB,iBAAiB;AAClB;AAEC;;IAEC,yBAAyB;AAC1B;AAEF;;EAEC,yBAAyB;AAC1B;AAEC;;GAEC,yBAAyB;AAC1B;AAED;;EAEC,yBAAyB;AAC1B;AAEC;;GAEC,yBAAyB;AAC1B;AAED;;EAEC,0BAA0B;AAC3B;AAEA;;EAEC,sCAAsC;EACtC,yCAAyC;AAC1C;AAEC;;GAEC,6CAA6C;AAC9C;AAED;;AAEC;;GAEC,mBAAmB;AACpB;AACD","sourcesContent":["<template>\r\n\t<nav id=\"topNav\" class=\"adminNav\">\r\n\t\t<router-link :to=\"{name: 'adminHome' }\" class=\"systemName\">{{systemName}} Admin</router-link>\r\n\t\t<router-link :to=\"{name: 'adminSettings' }\">Settings</router-link>\r\n\t\t<router-link :to=\"{name: 'adminMonitors' }\">Monitors</router-link>\r\n\t\t<router-link :to=\"{name: 'adminUsers' }\">Users</router-link>\r\n\t\t<router-link :to=\"{name: 'adminAddAgent' }\">Add Agent</router-link>\r\n\t\t<router-link :to=\"{name: 'adminGraphite' }\">Graphite</router-link>\r\n\t\t<router-link :to=\"{name: 'clientStatus' }\" class=\"linkToClient\">Client</router-link>\r\n\t\t<a role=\"button\" @click=\"logoutClicked\" class=\"logoutButton\">Log Out</a>\r\n\t</nav>\r\n</template>\r\n\r\n<script>\r\n\timport ExecAPI from 'appRoot/api/api.js';\r\n\texport default {\r\n\t\tdata: function ()\r\n\t\t{\r\n\t\t\treturn {\r\n\t\t\t\tsystemName: appContext.systemName\r\n\t\t\t};\r\n\t\t},\r\n\t\tcomputed:\r\n\t\t{\r\n\t\t},\r\n\t\tmethods:\r\n\t\t{\r\n\t\t\tlogoutClicked()\r\n\t\t\t{\r\n\t\t\t\tthis.$store.dispatch(\"Logout\")\r\n\t\t\t\t\t.then(data =>\r\n\t\t\t\t\t{\r\n\t\t\t\t\t\tthis.$router.push({ name: \"login\" });\r\n\t\t\t\t\t})\r\n\t\t\t\t\t.catch(err =>\r\n\t\t\t\t\t{\r\n\t\t\t\t\t\ttoaster.error(err);\r\n\t\t\t\t\t});\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n</script>\r\n\r\n<style scoped>\r\n\t.adminNav\r\n\t{\r\n\t\tposition: sticky;\r\n\t\ttop: 0px;\r\n\t\tdisplay: flex;\r\n\t\talign-items: center;\r\n\t\tjustify-content: space-between;\r\n\t\tflex-wrap: wrap;\r\n\t\tflex-direction: row;\r\n\t\tbackground-color: #FFFFFF;\r\n\t\tborder-bottom: 1px solid #AAAAAA;\r\n\t}\r\n\r\n\t\t.adminNav *\r\n\t\t{\r\n\t\t\tpadding: 10px 20px;\r\n\t\t\tcursor: pointer;\r\n\t\t\tfont-size: 20px;\r\n\t\t\tcolor: #000000;\r\n\t\t\ttext-decoration: none;\r\n\t\t\tflex: 1 1 auto;\r\n\t\t\ttext-align: center;\r\n\t\t\tbackground-color: #E8E8E8;\r\n\t\t\tborder-left: 1px solid #AAAAAA;\r\n\t\t\tborder-top: 1px solid #AAAAAA;\r\n\t\t\tmargin-top: -1px;\r\n\t\t\tmargin-left: -1px;\r\n\t\t}\r\n\r\n\t\t\t.adminNav *:hover\r\n\t\t\t{\r\n\t\t\t\tbackground-color: #F2F2F2;\r\n\t\t\t}\r\n\r\n\t.systemName\r\n\t{\r\n\t\tbackground-color: #82bf85;\r\n\t}\r\n\r\n\t\t.systemName:hover\r\n\t\t{\r\n\t\t\tbackground-color: #9bdc9e;\r\n\t\t}\r\n\r\n\t.logoutButton\r\n\t{\r\n\t\tbackground-color: #ffe4cb;\r\n\t}\r\n\r\n\t\t.logoutButton:hover\r\n\t\t{\r\n\t\t\tbackground-color: #fff6ed;\r\n\t\t}\r\n\r\n\t.router-link-active\r\n\t{\r\n\t\ttext-decoration: underline;\r\n\t}\r\n\r\n\t.linkToClient\r\n\t{\r\n\t\tbackground-color: var(--primary-color);\r\n\t\tcolor: var(--text-color-on-primary-color);\r\n\t}\r\n\r\n\t\t.linkToClient:hover\r\n\t\t{\r\n\t\t\tbackground-color: var(--primary-color-light2);\r\n\t\t}\r\n\r\n\t@media (min-width: 600px)\r\n\t{\r\n\t\tnav\r\n\t\t{\r\n\t\t\tflex-direction: row;\r\n\t\t}\r\n\t}\r\n</style>"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
